import { ReportFormData } from "../types/ReportFormData";

/**
 * Compares two ReportFormData objects to check if they are equal.
 * Handles Date objects, arrays, and nested objects properly.
 */
export const isFormDataEqual = (
	data1: ReportFormData,
	data2: ReportFormData
): boolean => {
	// Compare simple fields
	if (
		data1.report_title !== data2.report_title ||
		data1.client_name !== data2.client_name ||
		data1.campaign_name !== data2.campaign_name ||
		data1.exclude_holidays !== data2.exclude_holidays
	) {
		return false;
	}

	// Compare arrays
	if (
		JSON.stringify(data1.included_media_IDs.sort()) !==
		JSON.stringify(data2.included_media_IDs.sort()) ||
		JSON.stringify(data1.excluded_screen_IDs.sort()) !==
		JSON.stringify(data2.excluded_screen_IDs.sort()) ||
		JSON.stringify(data1.days.sort()) !== JSON.stringify(data2.days.sort())
	) {
		return false;
	}

	// Compare dates
	const compareDate = (d1: Date | null, d2: Date | null): boolean => {
		if (!d1 && !d2) return true;
		if (!d1 || !d2) return false;
		return d1.getTime() === d2.getTime();
	};

	if (
		!compareDate(data1.start_date, data2.start_date) ||
		!compareDate(data1.end_date, data2.end_date)
	) {
		return false;
	}

	// Compare specific_dates_to_exclude
	if (
		data1.specific_dates_to_exclude.length !==
		data2.specific_dates_to_exclude.length
	) {
		return false;
	}
	const dates1 = data1.specific_dates_to_exclude.map((d) => d.getTime()).sort();
	const dates2 = data2.specific_dates_to_exclude.map((d) => d.getTime()).sort();
	if (JSON.stringify(dates1) !== JSON.stringify(dates2)) {
		return false;
	}

	// Compare daily_working_hours
	if (data1.daily_working_hours.length !== data2.daily_working_hours.length) {
		return false;
	}
	if (
		JSON.stringify(data1.daily_working_hours) !==
		JSON.stringify(data2.daily_working_hours)
	) {
		return false;
	}

	// Compare offline_logs
	if (data1.offline_logs.length !== data2.offline_logs.length) {
		return false;
	}
	if (
		JSON.stringify(data1.offline_logs) !== JSON.stringify(data2.offline_logs)
	) {
		return false;
	}

	// Compare screen_renames
	if (data1.screen_renames.length !== data2.screen_renames.length) {
		return false;
	}
	if (
		JSON.stringify(data1.screen_renames) !==
		JSON.stringify(data2.screen_renames)
	) {
		return false;
	}

	// Compare screen_groups
	if (data1.screen_groups.length !== data2.screen_groups.length) {
		return false;
	}
	if (
		JSON.stringify(data1.screen_groups) !==
		JSON.stringify(data2.screen_groups)
	) {
		return false;
	}

	return true;
};
